<div *ngIf="user" class="wrapper" [matMenuTriggerFor]="userMenu">
  <div class="name" [ngClass]="{ external: externalOrg }">
    <span class="user-name">Hi, {{ user.firstName }}</span>
    <ng-icon name="featherChevronDown" class="ml-1" />
  </div>
  <img src="/assets/images/user.png" width="35" alt="user" />
</div>

<mat-menu #userMenu="matMenu">
  <div class="support-wrapper">
    For support: Email us at<br />
    <a href="mailto:help@rebuilt.com" class="support">{{
      'help@rebuilt.com'
    }}</a>
  </div>
  <div class="content">
    <app-profile-sidebar [embed]="true"></app-profile-sidebar>
  </div>
</mat-menu>

<div *ngIf="!user && homeScreen" class="text-sm">
  <span class="hidden 2xl:inline">For support: Email us at </span>
  <a href="mailto:help@rebuilt.com">{{ 'help@rebuilt.com' }}</a>
</div>

<app-shared-button
  *ngIf="!user && !homeScreen && !externalOrg"
  size="small"
  (click)="showSignInModal()"
>
  Join Rebuilt
</app-shared-button>
